import { type ShortcutMap } from '@vueron/kiska/provider';
import { getEnvValue } from '@vueron/kiska/util';

export enum LANG {
  CN = 'cn',
  EN = 'en',
  JP = 'jp',
  KO = 'ko',
}

export const KEYS = {
  STORAGE_LANG: 'STORAGE_LANG',
} as const;

export const APP_NAME =
  window.location.hostname === getEnvValue('VITE_APP_DOMAIN_VIEWER')
    ? 'viewer'
    : window.location.hostname === getEnvValue('VITE_APP_DOMAIN_DRIVE')
      ? 'drive'
      : 'nenana';

export const SHORTCUT_NAMESPACE = {
  DEFAULT: 'default',
} as const;

export const SHORTCUT_COMMAND = {
  [`${SHORTCUT_NAMESPACE.DEFAULT}.hello.world`]: `${SHORTCUT_NAMESPACE.DEFAULT}.hello.world`,
} as const;

export const SHORTCUT_MAP = {
  [SHORTCUT_NAMESPACE.DEFAULT]: [
    {
      key: ['Ctrl+KeyA'],
      command: SHORTCUT_COMMAND[`${SHORTCUT_NAMESPACE.DEFAULT}.hello.world`],
      title: 'dummy shorcut',
      category: 'dummy',
      description: '',
      inactivated: false,
    },
  ],
} as unknown as ShortcutMap<typeof SHORTCUT_NAMESPACE, typeof SHORTCUT_COMMAND>;

export enum SIDEBAR_MENU_POSITION {
  BOTTOM = 'bottom',
  TOP = 'top',
}
